import React, { useContext } from 'react'
import { Doughnut } from 'react-chartjs-2'
import LinkCard from '../../../components/LinkCard'
import { AppContext } from '../../../contexts/AppContext'

import { ArcElement, Chart as ChartJS, Tooltip } from 'chart.js'

ChartJS.register(ArcElement, Tooltip)

interface Props {
	percentage: number
	isDarkMode: boolean
	customStyles?: string
	customChartColor?: string
	clickHandler?: () => void
	variant?: 'blue'
	chevron?: boolean
	showHelp?: boolean
	helptext?: string
	shadow?: boolean
	texts: {
		title: string
		subText: string
		accuracy?: { text: string; color: string }
		range?: string
	}
}

// ChartJS.register(ArcElement, Tooltip)

const PercentageLinkCard: React.FC<Props> = ({
	percentage,
	texts,
	clickHandler,
	customStyles,
	customChartColor,
	chevron,
	showHelp,
	helptext = '',
	shadow,
}) => {
	const { isDarkMode } = useContext(AppContext)

	const chartColor = isDarkMode ? '#3cb49f' : '#52ae32'

	return (
		<LinkCard
			className={`${customStyles} text-dark dark:text-white dark:bg-brand-secondary-200-dark layout-xs ${shadow ? 'shadow-card' : ''}`}
			showHelpIcon={showHelp}
			helpIconText={helptext}
			{...texts}
			clickHandler={clickHandler}
			chevron={chevron}
		>
			<Doughnut
				options={{
					cutout: '70%',
					devicePixelRatio: 2,
					layout: {
						padding: 0,
					},
					plugins: {
						legend: {
							display: false,
						},
						tooltip: {
							enabled: false,
						},
					},
					responsive: true,
					maintainAspectRatio: false,
				}}
				data={{
					datasets: [
						{
							data: [percentage, 100 - percentage],
							backgroundColor: [customChartColor ? customChartColor : chartColor, '#e5e5e5'],
							borderWidth: 0,
						},
					],
				}}
			/>

			<div className='tooltip text-black dark:text-white'>{percentage}%</div>
		</LinkCard>
	)
}

export default PercentageLinkCard
